import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "ERP & CRM Platforms",
          "SaaS Product Development",
          "AI Automation & ML",
          "Web App Development",
          "Full-Stack Engineering",
          "Python & Node.js",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
